import { Menu, X } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Logo } from "./logo";

export function SiteHeader() {
  const [open, setOpen] = useState(false);
  const firstLink = useRef<HTMLAnchorElement>(null);
  const menuButton = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (open) firstLink.current?.focus();
  }, [open]);

  useEffect(() => {
    const onKey = (event: KeyboardEvent) => {
      if (event.key === "Escape" && open) {
        setOpen(false);
        menuButton.current?.focus();
      }
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open]);

  const close = () => setOpen(false);
  return (
    <header className="site-header">
      <Logo />
      <button
        ref={menuButton}
        className="icon-button menu-button"
        type="button"
        aria-expanded={open}
        aria-controls="site-nav"
        aria-label={open ? "Zatvori izbornik" : "Otvori izbornik"}
        onClick={() => setOpen((value) => !value)}
      >
        {open ? <X aria-hidden="true" /> : <Menu aria-hidden="true" />}
      </button>
      <nav
        id="site-nav"
        className={`site-nav ${open ? "site-nav--open" : ""}`}
        aria-label="Glavna navigacija"
      >
        <a ref={firstLink} href="/#kako-radi" onClick={close}>
          Kako radi
        </a>
        <a href="/#interijer" onClick={close}>
          Interijer
        </a>
        <a href="/#eksterijer" onClick={close}>
          Eksterijer
        </a>
        <a href="/#pitanja" onClick={close}>
          Pitanja
        </a>
        <Link className="button button--primary button--small" to="/app/new" onClick={close}>
          Isprobaj besplatno
        </Link>
      </nav>
    </header>
  );
}
